"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCompanyDocument = void 0;
/**
 * S3 Presigned-URLs grant temporary access to an S3 bucket,  allowing the user to complete an action on the bucket,  in this case, downloading a document, without requiring AWS credentials.

 */
var getCompanyDocument = function (instance) {
    return function (id, filename, config) {
        return instance.get("/users/companies/".concat(id, "/documents/").concat(filename), config);
    };
};
exports.getCompanyDocument = getCompanyDocument;
